import { useMediaQuery, useTheme } from '@mui/material';
import { Trans } from '@lingui/macro';
import { useRouter } from 'next/router';

import { ListButtonsColumn } from '../../../../modules/dashboard/lists/ListButtonsColumn';
import { useModalContext } from '../../../../hooks/useModal';
import { EPositionType, IEnrichedUniswapPosition } from '../../../../types/uniswapTokens';
import { PrimaryButton } from '../../../../ui-kit/PrimaryButton';
import { ROUTES } from '../../../primitives/Link';

export interface ILeverageActionsProps {
  position: IEnrichedUniswapPosition;
  uniswapLink?: string;
}

export const LeverageActions = ({ position, uniswapLink }: ILeverageActionsProps) => {
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));

  return md ? (
    <ListButtonsColumn size='big'>
      {position.type === EPositionType.Pool ? (
        <CreatePositionButton position={position} uniswapLink={uniswapLink} />
      ) : (
        <LeverageButton position={position} />
      )}
    </ListButtonsColumn>
  ) : (
    <>
      {position.type === EPositionType.Pool ? (
        <CreatePositionButton position={position} uniswapLink={uniswapLink} />
      ) : (
        <LeverageButton position={position} />
      )}
    </>
  );
};

const LeverageButton = ({ position }: ILeverageActionsProps) => {
  const { openLeveragePosition } = useModalContext();
  return (
    <PrimaryButton
      onClick={() => {
        position.tokenId && openLeveragePosition(position.tokenId.toString());
        window.gtag('event', 'leverage_leverage_click');
      }}
    >
      <Trans>Leverage</Trans>
    </PrimaryButton>
  )
};

const CreatePositionButton = ({ position }: ILeverageActionsProps) => {
  const router = useRouter();
  const onClickHeader = () => {
    window.gtag('event', 'leverage_create_position');
    router.push(ROUTES.leverageAdd(position.marketId, position.token0.underlyingAsset, position.token1.underlyingAsset));
  }
  return (
    <PrimaryButton onClick={onClickHeader}>
      <Trans>Create & Leverage</Trans>
    </PrimaryButton>
  );
};
